import { render, staticRenderFns } from "./CategoriesNew.vue?vue&type=template&id=3aaa19c0&scoped=true&"
import script from "./CategoriesNew.vue?vue&type=script&lang=js&"
export * from "./CategoriesNew.vue?vue&type=script&lang=js&"
import style0 from "./CategoriesNew.vue?vue&type=style&index=0&id=3aaa19c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aaa19c0",
  null
  
)

export default component.exports